module.exports = __webpack_public_path__ + "static/img/battle_report_jjc.7c672401.png";